import { render, staticRenderFns } from "./posterStepper.vue?vue&type=template&id=84f97dd8&scoped=true"
import script from "./posterStepper.vue?vue&type=script&lang=js"
export * from "./posterStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f97dd8",
  null
  
)

export default component.exports